import React, { useEffect, useState } from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField, IconButton, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper} from '@mui/material';
import { DeleteIcon, DeleteForever} from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';


export default function Categories() {
  const [categories, setCategories] = useState([]);
  const [open, setOpen] = useState(false);
  const [newCat, setNewCat] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    fetchCategories();
  }, []);

  const fetchCategories = async () => {
    const res = await axios.get('https://xcelitsolutions.co.uk/get_categories.php');
    setCategories(res.data);
  };

  const handleDelete = async (id) => {
  const res = await axios.post('https://xcelitsolutions.co.uk/delete_category.php', new URLSearchParams({ id }));
  console.log(res.data); // For debugging
  fetchCategories(); // Refresh list
};

  const handleAdd = async () => {
    if (newCat.trim()) {
      await axios.post('https://xcelitsolutions.co.uk/add_category.php', new URLSearchParams({ name: newCat.trim() }));
      
      setNewCat('');
      setOpen(false);
      fetchCategories();
}
else{
  alert("Please enter a category name.");
}
  };

  return (
    <div style={{ padding: 20 }}>
      <h2>Categories</h2>
      <Button variant="contained" onClick={() => setOpen(true)}>Add Category</Button>
      <Button variant="outlined" onClick={() => navigate('/products')} style={{ marginLeft: 10 }}>Back to Products</Button>


<TableContainer component={Paper} style={{ marginTop: 20 }}>
  <Table>
    <TableHead>
      <TableRow>
        <TableCell><strong>Category Name</strong></TableCell>
        <TableCell align="right"><strong>Actions</strong></TableCell>
      </TableRow>
    </TableHead>
    <TableBody>
      {categories.map((cat) => (
        <TableRow key={cat.id}>
          <TableCell>{cat.name}</TableCell>
          <TableCell align="right">
            <IconButton
              color="error"
              onClick={() => handleDelete(cat.id)}
              size="small"
              title="Delete Category"
            >
              <DeleteForever />
            </IconButton>
          </TableCell>
        </TableRow>
      ))}
    </TableBody>
  </Table>
</TableContainer>



      {/* <ul>
        {categories.map(category => (
          <li key={cat.id}>
            {cat.name}
            <IconButton
  color="error"
  label = "U+2421"
  onClick={() => handleDelete(cat.id)}
  size="small"
  title="Delete Category">
 <DeleteForever/>
 
</IconButton>
          </li>
        ))}
      </ul> */}

      <Dialog open={open} onClose={() => setOpen(false)}>
        <DialogTitle>Add Category</DialogTitle>
        <DialogContent>
          <TextField
            label="Category Name"
            value={newCat}
            onChange={(e) => setNewCat(e.target.value)}
            fullWidth
            margin="dense"
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpen(false)}>Cancel</Button>
          <Button onClick={handleAdd}>Add</Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
